import React, { useState } from 'react'
import { Select, Input, Divider, Typography } from 'antd'

const { Option } = Select
const { Link } = Typography

export default function SingleSelector({
  items = [],
  value,
  onChange,
  disabled = false,
  idKey = 'id',
  labelKey = 'name',
  placeholder = 'Select item',
  width = 290,
  getPopupContainer = (trigger) => trigger.parentNode,
}) {
  const [search, setSearch] = useState('')

  const filteredItems = items.filter(item =>
    (item[labelKey] || '').toLowerCase().includes(search.toLowerCase())
  )

  return (
    <Select
      showSearch={false}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      style={{ width }}
      optionLabelProp="label"
      getPopupContainer={getPopupContainer}
      popupRender={menu => (
        <div>
          <div style={{ padding: 8 }}>
            <Input
              placeholder="Search"
              value={search}
              onChange={e => setSearch(e.target.value)}
              size="small"
              allowClear
              autoFocus
            />
          </div>
          {menu}
          <Divider style={{ margin: '8px 0' }} />
          <div style={{ textAlign: 'right', padding: '0 8px 8px 8px', fontSize: 12, color: '#0075C9' }}>
            {filteredItems.length} items found
          </div>
        </div>
      )}
    >
      {filteredItems.map(item => {
        const id = item[idKey]
        const label = item[labelKey]
        return (
          <Option key={id} value={id} label={label}>
            {label}
          </Option>
        )
      })}
    </Select>
  )
}
